import { createFileRoute } from "@tanstack/react-router"
import { issueTypesViewLayoutHandle } from "src/views/IssueTypesView/constants"
import { IssueTypesView } from "src/views/IssueTypesView/IssueTypesView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/issue-types/")({
	component: IssueTypesView,
	staticData: issueTypesViewLayoutHandle,
})
